module.exports = __webpack_public_path__ + "static/img/6716_phase_function_Paper_Points.985ee36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6716_phase_function_Paper_Points.png
// module id = pQ+A
// module chunks = 0